module.exports = __webpack_public_path__ + "img/spell-book-open.19effee1.svg";